import { SyntheticEvent } from 'react'

export const addTagOnInputChange = (event: SyntheticEvent, value: string) => {
  if (value.endsWith(',')) {
    event.target.dispatchEvent(
      new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }),
    )
  }
}
